export default __webpack_public_path__ + "3a30ce53059762c49928ab5d57c26b88.png";